import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleCalendarIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M25.5 10.5L18.75 9.75L10.5 10.5L9.75 18L10.5 25.5L18 26.4375L25.5 25.5L26.25 17.8125L25.5 10.5Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5769 22.1362C13.0163 21.7574 12.6281 21.2043 12.4163 20.4731L13.7175 19.9368C13.8356 20.3868 14.0419 20.7356 14.3363 20.9831C14.6288 21.2306 14.985 21.3524 15.4013 21.3524C15.8269 21.3524 16.1925 21.2231 16.4981 20.9643C16.8038 20.7056 16.9575 20.3756 16.9575 19.9762C16.9575 19.5675 16.7963 19.2337 16.4738 18.9749C16.1513 18.7162 15.7463 18.5868 15.2625 18.5868H14.5106V17.2987H15.1856C15.6019 17.2987 15.9525 17.1862 16.2375 16.9612C16.5225 16.7362 16.665 16.4287 16.665 16.0368C16.665 15.6881 16.5375 15.4106 16.2825 15.2025C16.0275 14.9943 15.705 14.8893 15.3131 14.8893C14.9306 14.8893 14.6269 14.9906 14.4019 15.195C14.1769 15.3993 14.0138 15.6506 13.9106 15.9468L12.6225 15.4106C12.7931 14.9268 13.1063 14.4993 13.5656 14.13C14.025 13.7606 14.6119 13.575 15.3244 13.575C15.8513 13.575 16.3256 13.6762 16.7456 13.8806C17.1656 14.085 17.4956 14.3681 17.7338 14.7281C17.9719 15.09 18.09 15.495 18.09 15.945C18.09 16.4043 17.9794 16.7925 17.7581 17.1112C17.5369 17.43 17.265 17.6737 16.9425 17.8443V17.9212C17.3681 18.0993 17.715 18.3712 17.9888 18.7368C18.2606 19.1025 18.3975 19.5393 18.3975 20.0493C18.3975 20.5593 18.2681 21.015 18.0094 21.4143C17.7506 21.8137 17.3925 22.1287 16.9388 22.3574C16.4831 22.5862 15.9713 22.7025 15.4031 22.7025C14.745 22.7043 14.1375 22.5149 13.5769 22.1362Z",
			fill: "#2684FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5625 15.6787L20.1413 16.7118L19.4269 15.628L21.99 13.7793H22.9725V22.4999H21.5625V15.6787Z",
			fill: "#2684FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.5 32.25L32.25 25.5V24H25.5V25.5H24V32.25H25.5Z",
			fill: "#E94235"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.5 25.5H9V32.25H25.5V25.5Z",
			fill: "#00AC47"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 3.75C4.75687 3.75 3.75 4.75687 3.75 6V27H10.5V10.5H27V3.75H6Z",
			fill: "#2684FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.75 25.5V30C3.75 31.2431 4.75687 32.25 6 32.25H10.5V25.5H3.75Z",
			fill: "#00832D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.25 9H25.5V25.5H32.25V9Z",
			fill: "#FFBA00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.25 10.5V6C32.25 4.75687 31.2431 3.75 30 3.75H25.5V10.5H32.25Z",
			fill: "#0066DA"
		})
	]
});
export default SvgGoogleCalendarIcon;
